(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[50330],{

/***/ 70010:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[...slug]",
      function () {
        return __webpack_require__(68217);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 48007:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_Layout; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/react-toastify/dist/react-toastify.esm.mjs + 1 modules
var react_toastify_esm = __webpack_require__(22920);
// EXTERNAL MODULE: ./context/context.js
var context = __webpack_require__(94268);
;// CONCATENATED MODULE: ./components/Backdrop.js



var Backdrop = function() {
    var ref = (0,react.useContext)(context/* StoreContext */.x), backdrop = ref.backdrop, setBackdrop = ref.setBackdrop;
    if (backdrop) return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "fixed z-50 bg-black bg-opacity-70 w-screen inset-0 h-screen ",
        onClick: function() {
            setBackdrop(false);
        }
    });
};
/* harmony default export */ var components_Backdrop = (Backdrop);

// EXTERNAL MODULE: ./context/TranslationContext.js
var TranslationContext = __webpack_require__(73040);
;// CONCATENATED MODULE: ./components/FavouritesRight.js





var FavouritesList = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 88926).then(__webpack_require__.bind(__webpack_require__, 88926));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(88926)
            ];
        }
    },
    ssr: false
});
var FavouritesRight = function() {
    var Close = function Close() {
        setFavouritesIsOpen(0);
    };
    var favouritesRightTitle = (0,TranslationContext/* useTranslation */.m)().favouritesRightTitle;
    var ref = (0,react.useContext)(context/* StoreContext */.x), setFavouritesIsOpen = ref.setFavouritesIsOpen, favouritesIsOpen = ref.favouritesIsOpen;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "fixed  flex-col flex right-0 top-0 bg-white shadow-lg w-72 rounded-sm h-screen px-3 py-5 overflow-y-auto z-50 transition-all transform-gpu " + (favouritesIsOpen ? "translate-x-0 " : "translate-x-full "),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex justify-between items-center mb-3 ",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                        className: "text-lg inline-block",
                        children: favouritesRightTitle
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        onClick: function(e) {
                            Close();
                        },
                        children: "x"
                    })
                ]
            }),
            favouritesIsOpen ? /*#__PURE__*/ (0,jsx_runtime.jsx)(FavouritesList, {}) : null
        ]
    });
};
/* harmony default export */ var components_FavouritesRight = (FavouritesRight);

// EXTERNAL MODULE: ./node_modules/is-mobile/index.js
var is_mobile = __webpack_require__(63805);
var is_mobile_default = /*#__PURE__*/__webpack_require__.n(is_mobile);
;// CONCATENATED MODULE: ./components/Layout.js








var Menubar = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 11977).then(__webpack_require__.bind(__webpack_require__, 11977));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(11977)
            ];
        }
    },
    ssr: false
});
var WhatsappDesktop = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(63755), __webpack_require__.e(9012), __webpack_require__.e(75617)]).then(__webpack_require__.bind(__webpack_require__, 80039));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(80039)
            ];
        }
    },
    ssr: false
});
var Footer = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(63755), __webpack_require__.e(9012), __webpack_require__.e(31985)]).then(__webpack_require__.bind(__webpack_require__, 58114));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(58114)
            ];
        }
    }
});
var Layout = function(param) {
    var ssr = param.ssr, children = param.children, isAppWebView = param.isAppWebView, deviceType = param.deviceType;
    var ref = (0,react.useState)(false), isPhone = ref[0], setIsPhone = ref[1];
    var ref1 = (0,react.useContext)(context/* StoreContext */.x) || {}, setPage = ref1.setPage, setCurrentRoutingTypeId = ref1.setCurrentRoutingTypeId, currentRoutingTypeId = ref1.currentRoutingTypeId;
    (0,react.useEffect)(function() {
        setIsPhone(is_mobile_default()());
    }, []);
    (0,react.useEffect)(function() {
        setCurrentRoutingTypeId(ssr.RoutingTypeId);
        setPage(ssr.result);
    }, [
        ssr
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            children,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Backdrop, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_toastify_esm/* ToastContainer */.Ix, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_FavouritesRight, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Menubar, {
                ssr: ssr.result,
                RoutingTypeId: ssr.RoutingTypeId,
                isAppWebView: isAppWebView,
                deviceType: deviceType
            }),
            !isPhone ? /*#__PURE__*/ (0,jsx_runtime.jsx)(WhatsappDesktop, {}) : null,
            ssr.result.footer != "0" && ssr.disableHeader != true && /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer, {
                ssr: ssr
            })
        ]
    });
};
/* harmony default export */ var components_Layout = (Layout);


/***/ }),

/***/ 36289:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _context_TranslationContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73040);



var ReservationsLoading = function(param) {
    var className = param.className;
    var loadingText = (0,_context_TranslationContext__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .m)().loadingText;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        "aria-label": "Loading...",
        role: "status",
        className: "flex items-center space-x-2 h-full w-full justify-center " + className,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                className: "h-6 w-6 animate-spin stroke-gray-500",
                viewBox: "0 0 256 256",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("line", {
                        x1: "128",
                        y1: "32",
                        x2: "128",
                        y2: "64",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        strokeWidth: "24"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("line", {
                        x1: "195.9",
                        y1: "60.1",
                        x2: "173.3",
                        y2: "82.7",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        strokeWidth: "24"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("line", {
                        x1: "224",
                        y1: "128",
                        x2: "192",
                        y2: "128",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        strokeWidth: "24"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("line", {
                        x1: "195.9",
                        y1: "195.9",
                        x2: "173.3",
                        y2: "173.3",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        strokeWidth: "24"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("line", {
                        x1: "128",
                        y1: "224",
                        x2: "128",
                        y2: "192",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        strokeWidth: "24"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("line", {
                        x1: "60.1",
                        y1: "195.9",
                        x2: "82.7",
                        y2: "173.3",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        strokeWidth: "24"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("line", {
                        x1: "32",
                        y1: "128",
                        x2: "64",
                        y2: "128",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        strokeWidth: "24"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("line", {
                        x1: "60.1",
                        y1: "60.1",
                        x2: "82.7",
                        y2: "82.7",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        strokeWidth: "24"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                className: "text-xs font-medium text-gray-500",
                children: [
                    loadingText,
                    "..."
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ReservationsLoading);


/***/ }),

/***/ 68217:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ Meta; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(41799);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./components/Loaders/ReservationsLoading.js
var ReservationsLoading = __webpack_require__(36289);
;// CONCATENATED MODULE: ./components/DynamicComp.js





// import OwnerPanel from "./Pages/OwnerPanel";
// import Detail from "../components/Pages/Detail";
// import Blank from "../components/Pages/Blank";
// import BlogList from "../components/Pages/BlogList";
// import Contact from "../components/Pages/Contact";
// import BlogDetail from "../components/Pages/BlogDetail";
// import ProductCategory from "../components/Pages/ProductCategory";
// import Reservation from "../components/Pages/Reservation";
// import CategoryList from "../components/Pages/CategoryList";
// import CheckinInformation from "../components/Pages/CheckinInformation";
// import Payment from "../components/Pages/Payment";
// import Reservations from "../components/Pages/Reservations";
var Detail = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(63755), __webpack_require__.e(82175), __webpack_require__.e(42298), __webpack_require__.e(76964), __webpack_require__.e(99545), __webpack_require__.e(7762), __webpack_require__.e(9012), __webpack_require__.e(9842), __webpack_require__.e(56494), __webpack_require__.e(70235), __webpack_require__.e(57002), __webpack_require__.e(1237), __webpack_require__.e(76329)]).then(__webpack_require__.bind(__webpack_require__, 42544));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(42544)
            ];
        }
    }
});
var Blank = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(63755), __webpack_require__.e(60035), __webpack_require__.e(82175), __webpack_require__.e(42298), __webpack_require__.e(76964), __webpack_require__.e(99545), __webpack_require__.e(58355), __webpack_require__.e(69866), __webpack_require__.e(9012), __webpack_require__.e(90078)]).then(__webpack_require__.bind(__webpack_require__, 22068));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(22068)
            ];
        }
    }
});
var BlogList = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(63755), __webpack_require__.e(9012), __webpack_require__.e(76360), __webpack_require__.e(33651)]).then(__webpack_require__.bind(__webpack_require__, 60981));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(60981)
            ];
        }
    }
});
var Contact = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4841), __webpack_require__.e(61996)]).then(__webpack_require__.bind(__webpack_require__, 61996));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(61996)
            ];
        }
    }
});
var BlogDetail = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(63755), __webpack_require__.e(9012), __webpack_require__.e(76360), __webpack_require__.e(32043)]).then(__webpack_require__.bind(__webpack_require__, 78921));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(78921)
            ];
        }
    }
});
var ProductCategory = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(63755), __webpack_require__.e(42298), __webpack_require__.e(76964), __webpack_require__.e(7762), __webpack_require__.e(9012), __webpack_require__.e(9842), __webpack_require__.e(56494), __webpack_require__.e(70235), __webpack_require__.e(57002), __webpack_require__.e(1237), __webpack_require__.e(77675)]).then(__webpack_require__.bind(__webpack_require__, 1237));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(1237)
            ];
        }
    }
});
var Reservation = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(49774), __webpack_require__.e(63755), __webpack_require__.e(60035), __webpack_require__.e(82175), __webpack_require__.e(42298), __webpack_require__.e(76964), __webpack_require__.e(99545), __webpack_require__.e(58355), __webpack_require__.e(7762), __webpack_require__.e(9012), __webpack_require__.e(9842), __webpack_require__.e(56494), __webpack_require__.e(70235), __webpack_require__.e(57002), __webpack_require__.e(98555), __webpack_require__.e(1237), __webpack_require__.e(93981)]).then(__webpack_require__.bind(__webpack_require__, 4550));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(4550)
            ];
        }
    }
});
var CategoryList = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 82419).then(__webpack_require__.bind(__webpack_require__, 82419));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(82419)
            ];
        }
    }
});
var CheckinInformation = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(49774), __webpack_require__.e(60035), __webpack_require__.e(42298), __webpack_require__.e(94342)]).then(__webpack_require__.bind(__webpack_require__, 94342));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(94342)
            ];
        }
    }
});
var Payment = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(49774), __webpack_require__.e(63755), __webpack_require__.e(82175), __webpack_require__.e(99545), __webpack_require__.e(9012), __webpack_require__.e(51112)]).then(__webpack_require__.bind(__webpack_require__, 10559));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(10559)
            ];
        }
    }
});
var Reservations = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(49774), __webpack_require__.e(63755), __webpack_require__.e(60035), __webpack_require__.e(82175), __webpack_require__.e(99545), __webpack_require__.e(58355), __webpack_require__.e(9012), __webpack_require__.e(77103)]).then(__webpack_require__.bind(__webpack_require__, 4600));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(4600)
            ];
        }
    }
});
var OwnerPanel = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(82175), __webpack_require__.e(75882)]).then(__webpack_require__.bind(__webpack_require__, 75882));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(75882)
            ];
        }
    }
});
var BankTransferForm = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(63755), __webpack_require__.e(82175), __webpack_require__.e(99545), __webpack_require__.e(9012), __webpack_require__.e(12449)]).then(__webpack_require__.bind(__webpack_require__, 94777));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(94777)
            ];
        }
    }
});
// const Structural = dynamic(() => import("./Structural"));
var DynamicComp = function(props) {
    var c = {
        Detail: Detail,
        Page: Blank,
        BlogList: BlogList,
        BlogDetail: BlogDetail,
        Contact: Contact,
        ProductCategory: ProductCategory,
        Reservation: Reservation,
        Category: CategoryList,
        CheckinInformation: CheckinInformation,
        Payment: Payment,
        Reservations: Reservations,
        Owner: OwnerPanel,
        BankTransfer: BankTransferForm
    };
    var Comp = c[props.RoutingController];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Comp, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
            action: props.action
        }))
    });
};
/* harmony default export */ var components_DynamicComp = (DynamicComp);

// EXTERNAL MODULE: ./components/Layout.js + 2 modules
var Layout = __webpack_require__(48007);
;// CONCATENATED MODULE: ./pages/[...slug].js




var __N_SSP = true;
function Meta(param) {
    var data = param.data, index = param.index, isAppWebView = param.isAppWebView, deviceType = param.deviceType;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Page, {
        fallback: data,
        index: index,
        isAppWebView: isAppWebView,
        deviceType: deviceType
    });
};
var Page = function(param) {
    var fallback = param.fallback, index = param.index, isAppWebView = param.isAppWebView, deviceType = param.deviceType;
    var data = fallback;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: data.result.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: data.result.description
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "keywords",
                        content: data.result.keywords
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "author",
                        content: "https://www.villavillam.com.tr"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "publisher",
                        content: "https://www.villavillam.com.tr"
                    }),
                     false ? /*#__PURE__*/ 0 : /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "icon",
                        href: "/favicon.ico"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "viewport",
                        content: "width=device-width, initial-scale=1, maximum-scale=1"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "canonical",
                        href: data.result.canonical
                    }),
                    index ? /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "robots",
                        content: "noindex, nofollow"
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "robots",
                        content: "index, follow"
                    }),
                    (data === null || data === void 0 ? void 0 : data.result) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                property: "og:url",
                                content: data.result.canonical
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                property: "og:type",
                                content: "website"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                property: "og:title",
                                content: data.result.title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                property: "og:description",
                                content: data.result.description
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                property: "og:image",
                                content: "https://cdn.villavillam.com.tr" + "/uploads/" + data.result.resim
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                name: "twitter:card",
                                content: "summary_large_image"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                property: "twitter:domain",
                                content: "https://www.villavillam.com.tr"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                property: "twitter:url",
                                content: data.result.canonical
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                name: "twitter:title",
                                content: data.result.title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                name: "twitter:description",
                                content: data.result.description
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                name: "twitter:image",
                                content: "https://cdn.villavillam.com.tr" + "/uploads/" + data.result.resim
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout/* default */.Z, {
                ssr: data,
                isAppWebView: isAppWebView,
                deviceType: deviceType,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_DynamicComp, {
                    ssr: data,
                    page: data.result,
                    action: data.RoutingAction,
                    RoutingController: data.RoutingController,
                    isAppWebView: isAppWebView,
                    deviceType: deviceType
                })
            })
        ]
    });
};


/***/ }),

/***/ 69396:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectSpreadProps; }
/* harmony export */ });
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}

function _objectSpreadProps(target, source) {
  source = source != null ? source : {}
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(
        target,
        key,
        Object.getOwnPropertyDescriptor(source, key)
      );
    });
  }

  return target;
}

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [50174,49774,92888,40179], function() { return __webpack_exec__(70010); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);